import {Avatar} from 'antd'
import classNames from 'classnames'
import getAvatar from 'helpers/getAvatar'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {IoCheckmarkCircleOutline, IoCloseCircleOutline, IoRefreshCircle, IoTimeOutline,} from 'react-icons/io5'
import {Link} from 'react-router-dom'
import {SearchGroupIcon} from "../../../../components/AppIcon";
import {getType} from "../../../../apis/model/base";
import {OrgType} from "../../Organization/components/OrgType";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";

export const fromHostStatus = (value) => {
    switch (value) {
        case -1:
            return {
                label: 'pending',
                className: 'border border-blue-500 text-blue-500',
                icon: <IoTimeOutline size={12}/>,
            }
        case 1:
            return {
                label: 'approved',
                className: 'border border-green-500 text-green-500',
                icon: <IoCheckmarkCircleOutline size={12}/>,
            }
        case -8:
            return {
                label: 'has left',
                className: 'bg-orange-600 text-white',
                icon: <IoRefreshCircle size={12}/>,
            }
        case -9:
            return {
                label: 'rejected',
                className: 'border border-red-500 text-red-500',
                icon: <IoCloseCircleOutline size={12}/>,
            }
        default:
            return {}
    }
}

const HostContent = ({item, status, subItem, actions = null}) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const {label, className, icon} = fromHostStatus(status)
    const type = getType(item)

    return (
        <div className="flex gap-3">
            {isLg && (
                <Avatar
                    size={40}
                    className="mt-1 flex flex-center background-200"
                    shape={type === "organization" ? "square" : "circle"}
                    src={getAvatar(item)}
                    icon={<SearchGroupIcon size={20} type={type} className="text-color-500"/>}
                />
            )}
            <div className="flex flex-col flex-1 relative">
                <div className="flex flex-col flex-1">
                    <Link
                        to={getLinkToDetail(item)}
                        className="font-bold text-lg text-color-000 no-underline">
                        {getTitle(item)}
                    </Link>
                    {type === "organization"
                        ? (
                            <OrgType item={item} className="font-medium text-xs text-blue-500 italic tracking-wider"/>
                        ) : (
                            <div className="font-medium text-xs text-gray-500 italic tracking-wider">{t("user")}</div>
                        )}
                </div>
                <div className="my-2 border-b border-color-50"/>
                <div className="flex justify-end">
                    <div
                        style={{padding: '4px 12px', right: 8, bottom: 8}}
                        className={classNames(
                            'w-fit flex flex-center gap-1 truncate italic rounded-full',
                            className
                        )}>
                        {icon}
                        {label && (<span className="font-medium text-xs leading-tight">{t(label)}</span>)}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HostContent
